import {SHOP_CHEST_CONFIGS, TUTORIAL_CHEST_CONFIGS} from '../../configs/chests';

const CHEST_DISPLAY_NAMES = {
  chest_wooden: 'Деревянный сундук',
  chest_bronze: 'Бронзовый сундук',
  chest_silver: 'Серебряный сундук',
  chest_gold: 'Золотой сундук',
  chest_diamond: 'Алмазный сундук',
  chest_ruby: 'Рубиновый сундук',
  chest_god: 'Божественный сундук',
  ...Object.fromEntries([...SHOP_CHEST_CONFIGS, ...TUTORIAL_CHEST_CONFIGS].map((chest) => [chest.id, chest.name])),
};

export function getChestDisplayName(type) {
  return CHEST_DISPLAY_NAMES[type] || type;
}
